import { BLANK } from "../../src/config/constants";

export const getValueOrBlank = (value: string | number | null | undefined): string => {
    if(value === null || value === undefined) {
        return BLANK;
    }
    return isNaN(value as number) ? (value as string)?.trim() : value as string;
}
